import React from 'react';
import { PawPrintIcon } from 'lucide-react';
import { methodPills, skills } from '../data/content';
export function MethodOverview() {
  return <section className="bg-forest-800 px-5 py-12 sm:py-20" data-id="element-153" data-mp="v53mblfr2iio">
      <div className="mx-auto max-w-5xl text-center" data-id="element-154" data-mp="193bqoef48m3v">
        <p className="text-[0.62rem] font-bold uppercase tracking-[0.18em] text-gold-400 sm:text-xs sm:tracking-[0.2em]" data-id="element-155" data-mp="190pajqe5sya1">
          Sistema N°1 para ansiedad por separación
        </p>
        <h2 className="mt-2.5 font-display text-[1.75rem] leading-[1.05] text-cream-50 sm:mt-4 sm:text-5xl" style={{
        fontWeight: 700
      }} data-id="element-156" data-mp="1i1x4jw9n7cyb">
          Método Sin Culpa,
          <br className="hidden sm:block" data-id="element-157" data-mp="1rsrt57ad2omx" /> Sin Destrozos
        </h2>
        <p className="mt-2.5 text-[0.8rem] text-cream-200 sm:mt-5 sm:text-base" data-id="element-158" data-mp="1mvhx38sgveq4">
          7 Tomos + 5 Bonos · Cualquier raza y edad · Todo resuelto.
        </p>

        <ul className="mt-5 flex flex-wrap justify-center gap-1.5 sm:mt-9 sm:gap-2" data-id="element-159" data-mp="1wswcr66kfzhd">
          {methodPills.map(pill => <li key={pill} className="rounded-full bg-cream-50/[0.07] px-2.5 py-1 text-[0.7rem] font-medium text-cream-100 ring-1 ring-inset ring-cream-50/15 sm:px-3.5 sm:py-1.5 sm:text-sm" data-id="element-160" data-mp="1wl728j1ip27n">
              {pill}
            </li>)}
        </ul>

        <div className="mt-7 rounded-2xl bg-forest-900 p-4 text-left ring-1 ring-inset ring-cream-50/10 sm:mt-14 sm:p-8" data-id="element-161" data-mp="2akgjzn5dg4dq">
          <h3 className="text-center text-[0.62rem] font-bold uppercase tracking-[0.15em] text-gold-400 sm:text-sm" data-id="element-162" data-mp="2fii0q1fbrrm1">
            Habilidades que tu perro va a desarrollar
          </h3>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 sm:mt-6 sm:gap-x-8 sm:gap-y-3.5 lg:grid-cols-3" data-id="element-163" data-mp="2pa5qzz05b2lx">
            {skills.map(skill => <li key={skill} className="flex items-start gap-2 text-cream-100" data-id="element-164" data-mp="2y9ss0joyq6eg">
                <PawPrintIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-400 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-165" data-mp="2y7of5c935x21" />
                <span className="text-[0.78rem] leading-snug sm:text-[0.95rem]" data-id="element-166" data-mp="136mbrkck4no6">{skill}</span>
              </li>)}
          </ul>
        </div>

        <p className="mt-6 font-display text-base leading-snug text-cream-50 sm:mt-10 sm:text-2xl" style={{
        fontWeight: 600
      }} data-id="element-167" data-mp="y8unr1f19lp9">
          Funciona desde hoy, en tu casa, sin salir y sin gastar en adiestrador.
        </p>
      </div>
    </section>;
}